module.exports = __webpack_public_path__ + "img/webcam-toy-foto10.63cb31cd.jpg";